module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_c('c-settings'), _vm._v(" "), _c('div', {
    staticClass: "page-wrapper"
  }, [_c('component-header'), _vm._v(" "), _c('section', {
    staticClass: "home-page-two gw-banner-plain",
    attrs: {
      "id": "banner"
    }
  }, [_c('div', {
    staticClass: "container banner-inner"
  }, [_c('h1', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Explore Demos")]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.market), function(bz) {
    return _c('div', {
      staticClass: "col-md-3 col-xs-12"
    }, [_c('a', {
      attrs: {
        "href": '/' + bz.business_username
      }
    }, [_c('div', {
      staticClass: "business-view-card"
    }, [_c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": bz.business_banner_image
      }
    }), _vm._v(" "), _c('h3', {
      staticStyle: {
        "color": "#000000"
      }
    }, [_vm._v(_vm._s(bz.business_category))])])])])
  }))])]), _vm._v(" "), _c('component-footer')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5 offset-sm-4"
  }, [_c('div', {
    staticClass: "loading-md"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5dac3250"}!./src/pages/Demos/template.html
// module id = 262
// module chunks = 0